module.exports = __webpack_public_path__ + "img/3.bc3da16e.png";